import { create } from 'zustand';
import type { ConnectivityState } from '@shared/types';

interface ConnectivityStore {
  state: ConnectivityState;
  setState: (state: ConnectivityState) => void;
}

/**
 * UI-only store for application connectivity state.
 * Updated by SignalR events or health check polling.
 */
export const useConnectivityStore = create<ConnectivityStore>((set) => ({
  state: 'online',
  setState: (state) => set({ state }),
}));
